import type { FunctionComponent } from 'react';
import type { TypeCustomTagHalfBottleProps } from './types';

/**
 * CustomTagHalfBottle
 */
export const CustomTagHalfBottle: FunctionComponent<
  TypeCustomTagHalfBottleProps
> = ({
  className,
  lineOne,
  lineTwo,
  lineThree,
  lineOptional,
}: TypeCustomTagHalfBottleProps) => (
  <>
    <style>{`
      @font-face {
        font-family: 'Rockwell';
        src: local('Rockwell'), local('Rockwell'),
          url('/assets/fonts/RokkittRegular.woff2') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }

      @font-face {
        font-family: 'Seagram tfb';
        src: local('Seagram tfb'), local('Seagramtfb'),
          url('/assets/fonts/SeagramTFB.woff2') format('woff');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
    `}</style>

    <svg fill="none" viewBox="0 0 546 496" {...(className && { className })}>
      {lineOne && !lineTwo && !lineThree && (
        <text
          opacity={lineOne.opacity ?? 0.3}
          fill="#fff"
          xmlSpace="preserve"
          style={{ whiteSpace: 'pre', userSelect: 'none' }}
          fontFamily="Seagram tfb"
          fontSize="40.972"
          letterSpacing="0em"
          textAnchor="middle"
          x="50%"
          y="198.526"
        >
          {lineOne.value}
        </text>
      )}

      {lineOne && lineTwo && !lineThree && (
        <>
          <text
            opacity={lineOne.opacity ?? 0.3}
            fill="#fff"
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre', userSelect: 'none' }}
            fontFamily="Seagram tfb"
            fontSize="38.44"
            letterSpacing="0em"
            textAnchor="middle"
            x="50%"
            y="173.871"
          >
            {lineOne.value}
          </text>

          <text
            opacity={lineTwo.opacity ?? 0.3}
            fill="#fff"
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre', userSelect: 'none' }}
            fontFamily="Seagram tfb"
            fontSize="38.44"
            letterSpacing="0em"
            textAnchor="middle"
            x="50%"
            y="224.38"
          >
            {lineTwo.value}
          </text>
        </>
      )}

      {lineOne && lineTwo && lineThree && (
        <>
          <text
            opacity={lineOne.opacity ?? 0.3}
            fill="#fff"
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre', userSelect: 'none' }}
            fontFamily="Seagram tfb"
            fontSize="33.819"
            letterSpacing="0em"
            textAnchor="middle"
            x="50%"
            y="159.687"
          >
            {lineOne.value}
          </text>

          <text
            opacity={lineTwo.opacity ?? 0.3}
            fill="#fff"
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre', userSelect: 'none' }}
            fontFamily="Seagram tfb"
            fontSize="33.819"
            letterSpacing="0em"
            textAnchor="middle"
            x="50%"
            y="195.71"
          >
            {lineTwo.value}
          </text>

          <text
            opacity={lineThree.opacity ?? 0.3}
            fill="#fff"
            xmlSpace="preserve"
            style={{ whiteSpace: 'pre', userSelect: 'none' }}
            fontFamily="Seagram tfb"
            fontSize="33.819"
            letterSpacing="0em"
            textAnchor="middle"
            x="50%"
            y="231.733"
          >
            {lineThree.value}
          </text>
        </>
      )}

      {lineOptional && (
        <text
          opacity={lineOptional.opacity ?? 0.3}
          fill="#fff"
          xmlSpace="preserve"
          style={{ whiteSpace: 'pre', userSelect: 'none' }}
          fontFamily="Rockwell"
          fontSize="14"
          fontWeight="bold"
          letterSpacing="0em"
          textAnchor="middle"
          x="50%"
          y="320.492"
        >
          {lineOptional.value}
        </text>
      )}
    </svg>
  </>
);
